module.exports = __webpack_public_path__ + "static/media/CAS.a8c3ba5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/CAS.svg
// module id = 218
// module chunks = 0